import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareBehindSquare2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-behind-square-2, copy 2, layers, pages"><path fillRule="evenodd" clipRule="evenodd" d="M22 5C22 3.34315 20.6569 2 19 2H11C9.34315 2 8 3.34315 8 5V8H5C3.34315 8 2 9.34315 2 11V19C2 20.6569 3.34315 22 5 22H13C14.6569 22 16 20.6569 16 19V16H19C20.6569 16 22 14.6569 22 13V5ZM16 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V5C20.5 4.17157 19.8284 3.5 19 3.5H11C10.1716 3.5 9.5 4.17157 9.5 5V8H13C14.6569 8 16 9.34315 16 11V14.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSquareBehindSquare2;
